import usePageStats from "@/react/story/hooks/usePageStats";
import { StatsContext } from "@/react/story/providers/StatsContext";
import { type ReactNode, useMemo } from "react";

type Props = {
    statsEndpoint: string;
    statsToken: string;
    children: ReactNode;
}

export default function StatsProvider(props: Props) {
    const pageStats = usePageStats({
        statsEndpoint: props.statsEndpoint,
        statsToken: props.statsToken,
    });

    const context = useMemo(() => ({
        trackLinkClick: pageStats.trackLinkClick,
    }), [ pageStats.trackLinkClick ]);

    return (
        <StatsContext.Provider value={context}>
            {props.children}
        </StatsContext.Provider>
    );
}
